/**
 * Extract a human-readable error message from an API error.
 * Handles Django REST Framework error shapes: detail, non_field_errors, field errors.
 */
export function apiErrorMessage(err: unknown, fallback = 'Ocorreu um erro. Tente novamente.'): string {
  const data = (err as { response?: { data?: unknown } })?.response?.data;

  if (!data) {
    return err instanceof Error ? err.message : fallback;
  }

  // { detail: "..." }
  if (typeof (data as Record<string, unknown>).detail === 'string') {
    return (data as Record<string, string>).detail;
  }

  // { error: { message: "..." } }
  const apiError = (data as Record<string, unknown>).error;
  if (typeof apiError === 'object' && apiError !== null) {
    const message = (apiError as Record<string, unknown>).message;
    if (typeof message === 'string') return message;
  }

  // { non_field_errors: ["..."] }
  const nfe = (data as Record<string, unknown>).non_field_errors;
  if (Array.isArray(nfe) && nfe.length > 0) {
    return String(nfe[0]);
  }

  // { field: ["..."] } — first field error
  if (typeof data === 'object' && data !== null) {
    for (const value of Object.values(data as Record<string, unknown>)) {
      if (Array.isArray(value) && value.length > 0) return String(value[0]);
      if (typeof value === 'string') return value;
    }
  }

  return fallback;
}
